"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rose = void 0;
var mithril_1 = require("../mithril");
exports.rose = (0, mithril_1.m)('svg', {
    width: '400px',
    height: '400px',
    viewBox: '0 0 24 24'
}, [
    (0, mithril_1.m)('path', {
        d: 'm4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z',
        fill: 'currentColor',
        'stroke-width': '1%',
        stroke: 'white'
    })
]);
//# sourceMappingURL=rose.js.map